import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { Link } from 'react-router-dom'
import { useRef , useState} from 'react';
import {Button} from 'react-bootstrap'

const Uploader = () => {
    const [ image, setImage ] = useState(null)
    const [ fileName, setFileName ] = useState("no selected file")
}

const renderLabel = (field) => {
    return <Form.Label><b>{field.name}</b>{field.required ? <span style={{color:'rgb(240, 68, 56)'}}>*</span> : ''}</Form.Label>
}
const verticalCenter = {
    borderRadius: '100px',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    backgroundColor: 'white',
    right: -2,
    top: -5,
    cursor: 'pointer'
}
const renderError = (error) => {
    if (!error) {
        return <>
        </>;
    }
    return <div style={{color:'rgb(240, 68, 56)'}}>{error}</div>
}
export const renderField = (field,errors,data,onChange,onClick=null,Delete=null) => {
      let rendered = <></>;
    switch (field.type) {
        case 'rowTextarea':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Control className={errors[field.key]?'error-field':''} style={{height: '136px'}} as="textarea" rows={4} cols={100} value={data[field.key]}
                    onChange={event => onChange(field.key, event.target.value,null,field.size?field.size:1000,"rowTextarea")}
                    placeholder={field.placeholder} disabled={field?.disabled} />
                {renderError(errors[field.key])}
            </Form.Group></Col>
        break;
        case 'textarea':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Control as="textarea" className={errors[field.key]?'error-field':''} rows={1} value={data[field.key]}
                    onChange={event => onChange(field.key, event.target.value)}
                    placeholder="" />
                {renderError(errors[field.key])}
            </Form.Group></Col>
            break;
        case 'time':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Control type="time" value={data[field.key]}
                    className={errors[field.key]?'error-field':''}
                    onChange={event => onChange(field.key, event.target.value)}
                    placeholder="" disabled={field.disabled} />
                {renderError(errors[field.key])}
            </Form.Group></Col>
        break;
        case 'boolean':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Check rows={3} checked={data[field.key]}
                    onChange={event => onChange(field.key, event.target.checked)}
                    placeholder="" />
                {renderError(errors[field.key])}
            </Form.Group></Col>
            break;
        case 'select':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Select
                    className={errors[field.key]?'error-field':''}
                    value={data[field.key] && typeof data[field.key] === "object" ? data[field.key].id : data[field.key]}
                    onChange={event => onChange(field.key, event.target.value)} 
                 >
                    <option value=''>Please select</option>
                    {field.options.map(o => {
                        if (typeof o === "object") {
                            return <option value={o.value} key={o.value}>{o.label}</option>
                        }
                        return <option value={o} key={o}>{o}</option>
                    })}
                </Form.Select>

            </Form.Group>                    {renderError(errors[field.key])}
            </Col>
            break;
        case 'usermultiselect':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                    <Select 
                        className={errors[field.key]?'error-field':''}                                                                                                                                 options={field.options} isMulti={true}
                        value={field.serverToLocal(data[field.key], field.options)} onChange={(o) => {
                        onChange(field.key, field.localToServer(o))
                }}/>
                </Form.Group>                    {renderError(errors[field.key])}
                </Col>
            break;
        case 'multiselect':
            if (field.options.length === 0 || (data['id'] && !data[field.key])) {
                rendered = <></>;
            } else {
                rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Select 
                    className={errors[field.key]?'error-field':''}
                    options={field.options} isMulti={true}
                        defaultValue={field.serverToLocal(data[field.key])} onChange={(o) => {
                            onChange(field.key, field.localToServer(o))
                        }} />
                </Form.Group>                    {renderError(errors[field.key])}
                </Col>
            }
            break;
            case 'simpmultiselect':
                rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                    {renderLabel(field)}
                    <Select 
                        className={errors[field.key]?'error-field multiselect':''}
                        isMulti={true}  options={field.options}
                        value={data[field.key]}
                        onChange={event => onChange(field.key, event)}>
                    </Select>
                </Form.Group>                    {renderError(errors[field.key])}
                </Col>
            break;
        case 'date':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Control className={errors[field.key]?'error-field':''}
                type="date" value={data[field.key]}
                    onChange={event => onChange(field.key, event.target.value)}
                    placeholder="" />
            </Form.Group>                    {renderError(errors[field.key])}
            </Col>
            break;


// file upload STARTS........................................................

            case 'Multifileupload':
                rendered = <div className="main-file-upload"><Col md={6}><Form.Group controlId={field.key} key={field.key}>
                {/* {renderLabel(field)} */}
                <label className="form-label">Poster/Brochure</label>
            <div className="outer-file-upload"
                onClick ={() => document.querySelector(`.${field.class1}`).click()} 
                >
                <input type='file' className={errors[field.key]?'error-field':`${field.class1}`}
                    onChange={event => field.onchange(event, onChange)}
                    // onChange= {({ target : {files}}) => {
                    //     files[0] && setFileName(files[0].name)
                    //     if(files){
                    //         setImage(URL.createObjectURL(files[0]))
                    //     }
                    // }}
                    placeholder="Poster" hidden
                    />
                { 
                    data[field.key] 
                    ?
                    <img style={{ width: '100%', height: '350px', borderRadius:'5px' }} src={data[field.key]} alt="fileupload" /> 
                    :
                    <>
                    <img src={'../../../../images/fileupload1-icon.svg'} alt="fileupload" /> 
                    <p classsName="click-to-upload"><span style={{color:'blue'}}>Click to upload</span> or drag and drop SVG, PNG, JPG or GIF (max.800X400px)</p>
                    </>
                }
                 {/* <p classsName="click-to-upload"><span style={{color:'blue'}}>Click to upload</span> or drag and drop SVG, PNG, JPG or GIF (max.800X400px)</p> */}
            </div>
            </Form.Group>                 {renderError(errors[field.key])}
            </Col>


            <Col md={6}><Form.Group controlId={field.key1} key={field.key1}>
            {/* {renderLabel(field)}  */}
            <label className="form-label">Events Schedule</label>
            <div className="outer-file-upload"
            onClick ={() => document.querySelector(`.${field.class2}`).click()} 
            >
            <input type='file' className={errors[field.key1]?'error-field': `${field.class2}`}
                onChange={event => field.onchange2(event, onChange)}
                // onChange= {({ target : {files}}) => {
                //     files[0] && setFileName(files[0].name)
                //     if(files){
                //         setImage(URL.createObjectURL(files[0]))
                //     }
                // }}
                placeholder="Poster" hidden
                />
            { 
                data[field.key1] 
                ?
                <img style={{ width: '100%', height: '350px', borderRadius:'5px' }} src={data[field.key1]} alt="fileupload" /> 
                :
                <>
                <img src={'../../../../images/fileupload1-icon.svg'} alt="fileupload" /> 
                <p classsName="click-to-upload"><span style={{color:'blue'}}>Click to upload</span> or drag and drop SVG, PNG, JPG or GIF (max.800X400px)</p>
                </>
            }
            {/* <img src={'../../../../images/fileupload1-icon.svg'} alt="fileupload" /> 
            <p classsName="click-to-upload"><span style={{color:'blue'}}>Click to upload</span> or drag and drop SVG, PNG, JPG or GIF (max.800X400px)</p> */}
            </div>

            </Form.Group>                    {renderError(errors[field.key])}
            </Col>
            </div>
            break;

// file upload ENDS.......................................................

// Report -> Attendence
            case 'fileUploadExcel':
                rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                    
                    {renderLabel(field)}
                    <div className="outer-file-upload"  onClick ={() => document.querySelector(`.${field.class3}`)?.click()}>
                    <input type='file' className={errors[field.key]?'error-field':`${field.class2}`}
                        onChange={event => field.onchange(event, onChange)}
                        placeholder="Poster" hidden />
                            <img src={'../../../../images/fileupload1-icon.svg'} alt="fileupload" /> 
                            <p classsName="click-to-upload"><span style={{color:'blue'}}>Click to upload</span> or drag and drop PDF</p>
                    </div>
                    {data[field.key] &&
                    <div  className="uploaded-files">
                    <a href={data[field.key]} className="uploaded-content">
                        <div className="uploaded-inner-content">
                        <img style={{ height: '30px', borderRadius:'5px' }} 
                        id={`img`} src="../../images/Files-Icon-PNG-HD-Quality.png" />
                        <span class="uploaded-filename">file uploaded successfully</span>
                        </div>
                        </a>
                        <svg xmlns="http://www.w3.org/2000/svg" onClick={Delete} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 6h18"></path>
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                            <path d="M10 11v6"></path>
                            <path d="M14 11v6"></path>
                            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                        </svg>                    
                        </div>
                    }
                </Form.Group>                    {renderError(errors[field.key])}
                
                </Col>
            break;
            case 'fileUpload':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <input type='file' className={errors[field.key]?'error-field':''}
                    onChange={event => field.onchange(event, onChange)}
                    placeholder="Event Info" />
                {data[field.key] && 
                <a href={data[field.key]} target="_blank">
                    <img style={{ width: '100%', height: '310px', borderRadius:'5px' }} id={`img`} src="../../images/PDF_file_icon.svg.png" />
                </a>}
            </Form.Group>                    {renderError(errors[field.key])}
            </Col>
            break;

        case 'url':
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Control className={errors[field.key]?'error-field':''} type="url" value={data[field.key]}
                    onChange={event => field.onChange(data, event.target.value)}
                    placeholder="" disabled={field?.disabled} />
            </Form.Group>                    {renderError(errors[field.key])}
            </Col>
        default:
            rendered = <Col md={4}><Form.Group controlId={field.key} key={field.key}>
                {renderLabel(field)}
                <Form.Control className={errors[field.key]?'error-field':''} type="text" value={data[field.key]}
                    onChange={event => onChange(field.key, event.target.value)}
                    placeholder="" disabled={field?.disabled} />
            </Form.Group>                    {renderError(errors[field.key])}
            </Col>

    }

    if((field.notCondition && data[field.notCondition.key] == field.notCondition.value) || (field.notCondition && field.notCondition.check && field.notCondition.checkCon(data[field.notCondition.key])) ) {
        rendered = <Form.Control className={errors[field.key]?'error-field':''} type="hidden" value={data[field.key]}
            onChange={event => onChange(field.key, event.target.value)}
            placeholder="" />

    }
    
    if(field.condition && data[field.condition.key] !== field.condition.value) {
        rendered = <Form.Control className={errors[field.key]?'error-field':''} type="hidden" value={data[field.key]}
            onChange={event => onChange(field.key, event.target.value)}
            placeholder="" />

    }
    return rendered;
}
